import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import dateFormat from "dateformat";
import Rendertable from "./Rendertable";
import { getProductSearchResultforsales } from "../../../../actions/productDetails";
import { getSpecificProductAuditReport, getSpecificProductAuditItem } from "../../../../actions/productAuditAction";
import Excelldownload from "./Excelldownload";
import Stocklist from "./Stocklist";
import StocklistbyTitle from "./StocklistbyTitle";
// import ReactToPrint from "react-to-print";

import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Select,
  Skeleton,
  Button,
  Tabs,
} from "antd";
const { Option } = Select;

const SearchStock = ({
  getProductSearchResultforsales,
  getAllTransferLocation,
  getSpecificProductAuditReport,
  getSpecificProductAuditItem,
}) => {
  const { id } = useParams();
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [List, setList] = useState([]);
  const [ListTotal, setListTotal] = useState([]);
  const [data, setData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setloading] = useState(false);
  const [reload, setreload] = useState(false);
  const [auditsummary, setauditsummary] = useState({});
  const location = useRef("");
  const keyward = useRef("");
  const audit_health_stat = useRef("");
  const pageno = useRef(1);
  const page_size = useRef(10);
  let total_data = useRef({});

  const onChange = (event) => {
    if (event.keyCode == 13) {
      keyward.current = event.target.value;
      setreload(!reload);
    }
  };

  useEffect(() => {
    getSpecificProductAuditReport(id).then((result) => {
      setauditsummary(result);
      // console.log(result)
    });
  }, []);


  useEffect(() => {
    getSpecificProductAuditItem(
      "",
      "",
      id,
      1,
      1,
    ).then((result) => {
      setListTotal(result);
    });
  }, []);


  const onTabChange = key => {
    console.log(key);
  };

  useEffect(() => {
    setloading(false);
    getSpecificProductAuditItem(
      keyward.current,
      audit_health_stat.current,
      id,
      pageno.current,
      page_size.current,
    ).then((result) => {
      setList(result);
      setData(result.results);
      setloading(false);
    });
  }, [reload]);

  const renderdata = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <Rendertable
          List={List}
          pageno={pageno}
          page_size={page_size}
          setreload={setreload}
          reload={reload}
          setloading={setloading}
          total_data={total_data}
        />
      );
    }
  };




  const renderAuditSummary = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <>
          <Row >
            <Col span={4} style={{padding: "16px"}}>
              <h3>Issue Date</h3>
              <p>{dateFormat(auditsummary.issue_date, "mmmm dS, yyyy")}</p>
            </Col>
            <Col span={20} style={{padding: "16px"}}>
              <h3>Location</h3>
              <p>{auditsummary.location_name}</p>
            </Col>
          </Row>
          <Row >
            <Col span={4} style={{padding: "16px"}}>
              <h3>Total Inventory</h3>
              <p>{formatter.format(auditsummary.total_quantity)}</p>
            </Col>
            <Col span={4} style={{backgroundColor: "#f5f5f5", padding: "16px"}}>
              <h3>Total Audit Inventory</h3>
              <h4>Quantity: {formatter.format(auditsummary.total_audit_quantity)}</h4>
              <p>Valuation: {formatter.format(ListTotal.good_audit_valuation + ListTotal.missing_audit_valuation + ListTotal.excess_audit_valuation)} BDT</p>
            </Col>
            <Col span={8} style={{padding: "16px"}}>
              
            </Col>
            <Col span={4} style={{padding: "16px"}}>
              <h3>Total Remaining Inventory</h3>
              <p>{formatter.format(auditsummary.remaining)}</p>
            </Col>
          </Row>
          <Row style={{}}>
            <Col span={4} style={{padding: "16px"}}>
              <h3>Total Variation Count</h3>
              <p>{formatter.format(auditsummary.total_variation_count)}</p>
            </Col>
            <Col span={4} style={{backgroundColor: "#f5f5f5", padding: "16px"}}>
              <h3>Good</h3>
              <h4>Quantity: {formatter.format(auditsummary.good_audit_count)}</h4>
              <p>Valuation: {formatter.format(ListTotal.good_audit_valuation)} BDT</p>
            </Col>
            <Col span={4} style={{backgroundColor: "#f5f5f5", padding: "16px"}}>
              <h3>Missing </h3>
              <h4>Quantity: {formatter.format(auditsummary.missing_audit_count)}</h4>
              <p>Valuation: {formatter.format(ListTotal.missing_audit_valuation)} BDT</p>
            </Col>
            <Col span={4} style={{backgroundColor: "#f5f5f5", padding: "16px"}}>
              <h3>Excess</h3>
              <h4>Quantity: {formatter.format(auditsummary.excess_audit_count)}</h4>
              <p>Valuation: {formatter.format(ListTotal.excess_audit_valuation)} BDT</p>
            </Col>
            <Col span={4} style={{padding: "16px"}}>
              <h3>Pending </h3>
              <h4>Quantity: {formatter.format(auditsummary.pending_audit_count)}</h4>
              <p>Valuation: {formatter.format(ListTotal.pending_audit_valuation)} BDT</p>
            </Col>
          </Row>
        </>
      );
    }
  };

  return (
    <>
      {/* Audit summary */}
      {renderAuditSummary()}
      <Divider />
      <Row>
        <Col span={10}>
          <h3>Enter barcode or product code for instant Search</h3>
          <AutoComplete
            placeholder="input search text"
            onKeyUp={onChange}
            style={{ width: "100%" }}
          />
        </Col>
        
        {/* <Col span={6} offset={1}>
          <h3>Audit status</h3>
          <Select
            placeholder="Status"
            style={{ width: "100%" }}
            onChange={(e) => {
              audit_health_stat.current = e;
              setloading(true);
              setreload(!reload);
            }}
          >
            <Option value="">All</Option>
            <Option value="Good">Good</Option>
            <Option value="Missing in Stock">Missing in Stock</Option>
            <Option value="Excess in Stock">Excess in Stock</Option>
          </Select>
        </Col> */}
        {/* <Col span={2} offset={1}>
          <h3>Export</h3>
          <Excelldownload data={data} />
        </Col> */}

        
      </Row>


      
      
      <Divider />
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab={<span style={{fontWeight: "semi-bold", color: "green"}}><h3>Good (<span style={{color: "green", fontWeight: "bold"}}>{List.good_audit_count}</span>)</h3><p>Valuation: {formatter.format(List.good_audit_valuation)}</p></span>} key="1">
          <StocklistbyTitle
            reload={reload}
            setreload={setreload}
            keyward={keyward}
            audit_health_stat="Good"
            id={id}
          />
          <Stocklist 
            reload={reload}
            setreload={setreload}
            keyward={keyward}
            audit_health_stat="Good"
            id={id}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab={<span style={{fontWeight: "semi-bold", color: "red"}}><h3>Missing in Stock (<span style={{color: "red", fontWeight: "bold"}}>{List.missing_audit_count}</span>)</h3><p>Valuation: {formatter.format(List.missing_audit_valuation)}</p></span>} key="2">
        <StocklistbyTitle
            reload={reload}
            setreload={setreload}
            keyward={keyward}
            audit_health_stat="Missing in Stock"
            id={id}
          />
          <Stocklist 
            reload={reload}
            setreload={setreload}
            keyward={keyward}
            audit_health_stat="Missing in Stock"
            id={id}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab={<span style={{fontWeight: "semi-bold", color: "orange"}}><h3>Excess in Stock (<span style={{color: "orange", fontWeight: "bold"}}>{List.excess_audit_count}</span>)</h3><p>Valuation: {formatter.format(List.excess_audit_valuation)}</p></span>} key="3">
        <StocklistbyTitle
            reload={reload}
            setreload={setreload}
            keyward={keyward}
            audit_health_stat="Excess in Stock"
            id={id}
          />
          <Stocklist 
            reload={reload}
            setreload={setreload}
            keyward={keyward}
            audit_health_stat="Excess in Stock"
            id={id}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab={<span style={{fontWeight: "semi-bold", color: "gray"}}><h3>Pending Audit (<span style={{color: "gray", fontWeight: "bold"}}>{List.pending_audit_count}</span>)</h3><p>Valuation: {formatter.format(List.pending_audit_valuation)}</p></span>} key="4">
        <StocklistbyTitle
            reload={reload}
            setreload={setreload}
            keyward={keyward}
            audit_health_stat="Pending"
            id={id}
          />
          <Stocklist 
            reload={reload}
            setreload={setreload}
            keyward={keyward}
            audit_health_stat="Pending"
            id={id}
          />
        </Tabs.TabPane>
      </Tabs>
      {/* {renderdata()} */}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    // List: state.ProductDetails.productdetails,
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, {
  getProductSearchResultforsales,
  getSpecificProductAuditReport,
  getSpecificProductAuditItem,
})(SearchStock);
